import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=3646df3a&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=ts&"
export * from "./Game.vue?vue&type=script&lang=ts&"
import style0 from "./Game.vue?vue&type=style&index=0&id=3646df3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3646df3a",
  null
  
)

export default component.exports